export default {
	getItems: state => state.items,
	getTimeline: state => state.timeline,
	getIsDailyHistory: state =>state.is_daily_history,
}